import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import { map } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type':'application/json'})
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private url = '/login/';
  constructor(public http:HttpClient) { }

  login(data):Observable<any>{
    return this.http.post(this.url, data, httpOptions)
    .pipe(map(this.extractData), catchError(this.handleErrors))
  }

  private handleErrors<T>(result?:T): any{
    return (error:any): Observable<T> => {
      return of(result as T);
    }
  }

  public extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  private save_token(data) {
    if (data.success) {
        localStorage.setItem('token', data.token);
        return;
    }
}

}
